import React from "react";
import "./HealthAndSefty.less";
import DatacenterList from "../../common/DatacenterList/DatacenterList";
import HealthAndSeftyGrphBarChart from "./HealthAndSeftyGrphBarChart";
import moment from "moment";
import { apiRequest } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import SliderDatePicker from "../../common/SliderDatePicker/SliderDatePicker";
import {
  Chip
} from "@material-ui/core";
import { ShowToast, toastType } from "../../../utils/toast-service";
import { kpiRadioSlider } from "../../../utils/helper";
import { standardDateFormat } from "../../../constants/appConstants";

class HealthAndSefty extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datacenterList: undefined,
      selectedPropertyId:
        localStorage.getItem("selectedPropertyIdMultiple") != undefined
          ? localStorage.getItem("selectedPropertyIdMultiple")
          : 0,
      endDate: moment(localStorage.getItem("selectedendDate"))
        .endOf("month")
        .format("L"),
      startDate: moment(localStorage.getItem("selectedstartDate"))
        .startOf("month")
        .format("L"),

      selectedDatacenterNames:
        localStorage.getItem("selectedPropertyIdMultipleNames") != null
          ? localStorage.getItem("selectedPropertyIdMultipleNames").split(",")
          : [],
      selectedPropertyAbbr:
        localStorage.getItem("Abbreviation") != null
          ? localStorage.getItem("Abbreviation").split(",")
          : [],
      typeOfDate: "Month",
      isChangedDC: false,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    if (this.state.datacenterList == undefined) {
      this.getDataCenterList();
    }
    if (localStorage.getItem("DateRadioSelect") == "YTD") {
      const year = moment(
        localStorage.getItem("selectedstartDate"),
        "MM/DD/YYYY"
      ).format("YYYY");
      localStorage.setItem("selectedstartDate", "01/01/" + year);
    }
  }

 
  /** Get master data center list */
  getDataCenterList = () => {
    apiRequest({ url: API_URL.datacenter.getDatacenterList }).then(
      ({ data: datacenterList }) => {
        this.setState({
          datacenterList: datacenterList
        });
      }
    );
  };

/** set selected property list  */
  onPropertySelect = (id, selectedDatacenterNames, abbr) => {
    const idList = id.toString();
    const {isChangedDC}= this.state;
    localStorage.setItem("selectedPropertyIdMultiple", id);
    this.setState({
      selectedPropertyId: idList,
      selectedDatacenterNames: selectedDatacenterNames,
      selectedPropertyAbbr: abbr,
      isChangedDC: !isChangedDC
    });
  };


  /** set date */
  handelDateChangesSlideDate = (start, end, typeOfDate) => {
    this.setState({
      startDate: start,
      endDate: end,
      typeOfDate: typeOfDate,
    });
  };

  /** Call on abbreviation delete click */
  abbreviationHandleDelete = value => {
    const {selectedPropertyId, selectedDatacenterNames, selectedPropertyAbbr, datacenterList, isChangedDC} = this.state;
    let propertyIDToRemove = selectedPropertyId.split(",");
    if (propertyIDToRemove.length == 1) {
      ShowToast(
        "You cannot deselect all the Data Centers.",
        toastType.WARNING,
        5000,
        null
      );
      return false;
    }
    let propertyNameToRemove = selectedDatacenterNames;
    let propertyAbToRemove = selectedPropertyAbbr;
    const obj = datacenterList.find(o => o.abbreviation === value);

    propertyIDToRemove = propertyIDToRemove.filter(function(item) {
      return item != obj.propertyID;
    });

    propertyNameToRemove = propertyNameToRemove.filter(function(item) {
      return item !== obj.name;
    });

    propertyAbToRemove = propertyAbToRemove.filter(function(item) {
      return item !== value;
    });


    localStorage.setItem(
      "selectedPropertyIdMultiple",
      propertyIDToRemove.toString()
    );
    localStorage.setItem(
      "selectedPropertyIdMultipleNames",
      propertyNameToRemove.toString()
    );
    localStorage.setItem("Abbreviation", propertyAbToRemove.toString());

    this.setState({
      selectedPropertyId: propertyIDToRemove.join(","),
      selectedDatacenterNames: propertyNameToRemove,
      selectedPropertyAbbr: propertyAbToRemove,
      isChangedDC: !isChangedDC
    });
  };

  render() {
    const {
      selectedPropertyId
    } = this.state;

    return (
      <>
        <Grid container>
          <Grid item xs={12}>
            <div className={"hscContainer"}>
              <Grid container>
                <Grid item xs={12} sm={6} lg={4}>
                  <Box className={" reports-dclist"} pl={1} pt={2} pb={2}>
                    <DatacenterList
                      dataSource={this.state.datacenterList}
                      onPropertySelect={this.onPropertySelect}
                      selectedPropertyId={selectedPropertyId}
                      classTitle={"dc-list-reports"}
                      SeType={"MultipleMaterial"}
                      isChangedDC={this.state.isChangedDC}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={1} lg={1}>
                  {" "}
                </Grid>
                <Grid item xs={12} sm={5} lg={7}>
                  <Box className={" reports-datepicker"} pr={1} pt={2} pb={2}>
                    <SliderDatePicker
                      handelDateChangesSlideDate={
                        this.handelDateChangesSlideDate
                      }
                      selectedDate={moment().format(standardDateFormat)}
                      radioSlider={kpiRadioSlider}
                      isAll
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} className={"dataCenter-list-div common-colour"}>
                  <b>{"Selected Data Centers:"}</b>{" "}
                  {this.state.selectedPropertyAbbr.map((value, index) => (
                    <Chip
                      label={value}
                      onDelete={() => this.abbreviationHandleDelete(value)}
                      variant={"outlined"}
                      style={{ marginLeft: "4px" }}
                      key={index + "HSChip"}
                      className={"common-colour"}
                    />
                  ))}
                </Grid>

                <Grid container>
                  <Grid
                    item
                    xs={12}
                  >
                    <Box>
                      <div className={"w-100 graph-div-report"}>
                        <HealthAndSeftyGrphBarChart
                          conf={2}
                          reference={"HealthandSafetyBarChart2"}
                          propertyId={this.state.selectedPropertyId}
                          endDate={this.state.endDate}
                          startDate={this.state.startDate}
                          typeOfDate={this.state.typeOfDate}
                          dataSource={this.state.datacenterList}
                        />
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </>
    );
  }
}

export default HealthAndSefty;
